export default {"src":"/_next/static/media/chapter-5-icon-circular.58370aae.svg","height":137,"width":138,"blurWidth":0,"blurHeight":0};